/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Point_VesselsInputs */



/**
* | output |
* | --- |
* | "Attending tankers, bulk carriers, barges and offshore units" |
*
* @param {Team_Point_VesselsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const team_point_vessels = /** @type {((inputs?: Team_Point_VesselsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Point_VesselsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("服务油轮、散货船、驳船和海上装置")
	return /** @type {LocalizedString} */ ("Attending tankers, bulk carriers, barges and offshore units")
});